// src/models/servicos/OrdemServicoFiltroAvancado.js
export const CAMPOS_FILTRO_AVANCADO_OS = [
  { campo: 'problemaRelatado', label: 'Problema relatado' },
  { campo: 'observacaoEntrada', label: 'Observação de entrada' },
  { campo: 'diagnostico', label: 'Diagnóstico' },
  { campo: 'produtoId', label: 'Código do produto/serviço' },
  { campo: 'xProd', label: 'Descrição do item' },
  { campo: 'observacaoItem', label: 'Observação do item' },
];

export class OrdemServicoFiltroAvancado {
  constructor(dados = {}) {
    CAMPOS_FILTRO_AVANCADO_OS.forEach(({ campo }) => {
      this[campo] = String(dados[campo] ?? '').trim();
    });
  }

  validar() {
    const codigo = Number(this.produtoId);
    if (this.produtoId && (!Number.isInteger(codigo) || codigo <= 0 || codigo > 2147483647)) {
      return 'Informe um código de produto ou serviço válido, maior que zero.';
    }
    return null;
  }

  paraParametros() {
    return Object.fromEntries(CAMPOS_FILTRO_AVANCADO_OS.map(({ campo }) => [
      campo,
      this[campo] ? (campo === 'produtoId' ? Number(this[campo]) : this[campo]) : undefined,
    ]));
  }
}
